var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.251,
    height: 31,
    viewBox: "0 0 27.251 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3615.726 4742)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M152.8,620.356a7.415,7.415,0,0,1,1.256.557,2.518,2.518,0,0,1,1.1,2.087c.018.453,0,.907,0,1.362.429.176.859.32,1.259.523a9.257,9.257,0,0,1,5.4,8.392c.044,1.068-.006,2.141.065,3.206a13.737,13.737,0,0,0,2.688,7.306c.356.488.76.942,1.159,1.4a.932.932,0,0,1-.729,1.634q-12.564-.006-25.128,0a.952.952,0,0,1-.983-.558.93.93,0,0,1,.257-1.074,13.828,13.828,0,0,0,3.615-7.029,24.439,24.439,0,0,0,.283-2.975,31.448,31.448,0,0,1,.141-3.229,9.189,9.189,0,0,1,6.247-7.472c.084-.032.171-.057.279-.094,0-.392,0-.784,0-1.176a2.715,2.715,0,0,1,2.251-2.81.677.677,0,0,0,.11-.046Zm.541,3.652c0-.347.018-.678,0-1.007a.9.9,0,0,0-.854-.826.885.885,0,0,0-.929.736,8.781,8.781,0,0,0-.009,1.1Z",
    transform: "translate(3476.912 -5362.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M256.537,970.095h8.21c-.342,1.429-2.354,2.731-4.168,2.71C258.819,972.784,256.834,971.457,256.537,970.095Z",
    transform: "translate(3368.712 -5683.805)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.7ed3579f.svg";
export { ForwardRef as ReactComponent };